import { useTranslation } from 'react-i18next'
import { ScrollFade } from '@/components/ScrollFade'

const SHOW_LOGOS = false // flip to true once logo permissions land (Techstars / Expert DOJO)

export function Pinned() {
  const { t } = useTranslation()
  const proofs = [
    { key: 'noSchema', label: t('pinned.proofs.noSchema'), body: t('lorem:pinned.proof1') },
    { key: 'sameTools', label: t('pinned.proofs.sameTools'), body: t('lorem:pinned.proof2') },
    { key: 'modelsChange', label: t('pinned.proofs.modelsChange'), body: t('lorem:pinned.proof3') },
  ]

  return (
    <section className="max-w-7xl mx-auto px-5 md:px-8 py-14 md:py-20">
      <ScrollFade as="p" className="text-3xl md:text-4xl font-bold font-display">
        {t('lorem:pinned.statement')}
      </ScrollFade>
      <ScrollFade className="mt-6 text-lg md:text-xl opacity-80 leading-relaxed max-w-3xl">
        {t('lorem:pinned.intro')}{' '}
        <strong>{t('lorem:pinned.intro_conclusion')}</strong>
      </ScrollFade>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">
        {proofs.map((p, i) => (
          <ScrollFade
            key={p.key}
            className="p-5 rounded-lg border border-mono-800/[0.16] dark:border-mono-100/[0.16] bg-gradient-to-b from-mono-800/[0.06] to-mono-800/[0.02] dark:from-mono-100/[0.06] dark:to-mono-100/[0.02]"
            delay={i * 100}
          >
            <div className="text-base font-semibold mb-2">{p.label}</div>
            <p className="text-lg opacity-75 leading-relaxed">{p.body}</p>
          </ScrollFade>
        ))}
      </div>
      {SHOW_LOGOS && (
        <div className="mt-12 opacity-60 text-xs uppercase tracking-wider text-center">
          [ partner logos render here once permissions confirmed ]
        </div>
      )}
    </section>
  )
}
